var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetailsAssetsProvince(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 144,
    viewBox: "0 0 85 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3416",
    "data-name": "Group 3416",
    transform: "translate(-1605.75 -554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1662",
    "data-name": "Rectangle 1662",
    transform: "translate(1605.75 556)",
    fill: "#fff",
    stroke: "#151b47",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,0H76a9,9,0,0,1,9,9V55a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V9A9,9,0,0,1,9,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,.5H76A8.5,8.5,0,0,1,84.5,9V54.5a0,0,0,0,1,0,0H.5a0,0,0,0,1,0,0V9A8.5,8.5,0,0,1,9,.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1663",
    "data-name": "Rectangle 1663",
    transform: "translate(1605.75 556)",
    fill: "#151b47",
    stroke: "#151b47",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,0H76a9,9,0,0,1,9,9v6a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V9A9,9,0,0,1,9,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,.5H76A8.5,8.5,0,0,1,84.5,9v5.5a0,0,0,0,1,0,0H.5a0,0,0,0,1,0,0V9A8.5,8.5,0,0,1,9,.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Islands",
    transform: "translate(1630.75 567)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Islands")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_384",
    "data-name": "Rectangle 384",
    transform: "translate(1605.75 650)",
    fill: "#fff",
    stroke: "#151b47",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H85a0,0,0,0,1,0,0V39a9,9,0,0,1-9,9H9a9,9,0,0,1-9-9V0A0,0,0,0,1,0,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5.5h84a0,0,0,0,1,0,0V39A8.5,8.5,0,0,1,76,47.5H9A8.5,8.5,0,0,1,.5,39V.5A0,0,0,0,1,.5.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_390",
    "data-name": "Rectangle 390",
    transform: "translate(1605.75 603)",
    fill: "#fff",
    stroke: "#151b47",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,0H76a9,9,0,0,1,9,9V48a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V9A9,9,0,0,1,9,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,.5H76A8.5,8.5,0,0,1,84.5,9V47.5a0,0,0,0,1,0,0H.5a0,0,0,0,1,0,0V9A8.5,8.5,0,0,1,9,.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_389",
    "data-name": "Rectangle 389",
    transform: "translate(1605.75 603)",
    fill: "#151b47",
    stroke: "#151b47",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 84,
    height: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Travel_Agents",
    "data-name": "Travel Agents",
    transform: "translate(1613.75 614)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Travel Agents")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_387",
    "data-name": "Rectangle 387",
    transform: "translate(1605.75 650)",
    fill: "#151b47",
    stroke: "#151b47",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 84,
    height: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Yacht_Lists",
    "data-name": "Yacht Lists",
    transform: "translate(1622.75 661)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Yacht Lists")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsAssetsProvince);
export default __webpack_public_path__ + "static/media/detailsAssetsProvince.3501f04d5cda5d75b719ad9facdfa130.svg";
export { ForwardRef as ReactComponent };